/**
 * Uplifted from `utils/restrictionConstants.ts` — the file exists in BOTH apps.
 *
 * **45 of web's 47 exports are byte-identical to mobile's 45** (measured by symbol/body diff
 * after whitespace normalisation: 0 mobile-only, 0 differing bodies). They are all here. The
 * two web-only names — `POST_FINAL_INVENTORY_ACTIVITY` and `CASH_DRAWER_ACCESS` — live in
 * `index.desktop.ts`.
 *
 * These are RESTRICTION CODES: each is compared by value against the user's restriction list,
 * never iterated, so neither declaration order nor the presence of extra names on one platform
 * affects the other. Pure data — no imports, nothing read at load time.
 *
 * ⚠️ Two of them are NOT their own name, and that is deliberate in both apps — do not
 * "correct" either: `CASH_MANAGEMENT` is `"DAILY_CLOSING"`, and `RESTRICT_MANUAL_SOLD_OUT` /
 * `RESTRICT_MANUAL_STOCK_IN` are camelCase values while every neighbour is SCREAMING_SNAKE.
 */
export const INVOICE_REPRINT = "INVOICE_REPRINT";
export const APPLY_DISCOUNT = "APPLY_DISCOUNT";
export const OVERRIDE_DISCOUNT = "OVERRIDE_DISCOUNT";
export const SAVE_ORDER = "SAVE_ORDER";
export const DISABLE_PAYMENT_SAVE = "DISABLE_PAYMENT_SAVE";
export const VOID_SALE = "VOID_SALE";
export const CANCEL_SALE = "CANCEL_SALE";
export const UNVOID_SALE = "UNVOID_SALE";
export const UNCANCEL_SALE = "UNCANCEL_SALE";
export const VIEW_CLOSED_ORDERS = "VIEW_CLOSED_ORDERS";
export const CLOSE_SALE_BALANCE = "CLOSE_SALE_BALANCE";
export const SOLD_OUT_ITEMS = "SOLD_OUT_ITEMS";
export const NON_CHARGEABLE_SALE = "NON_CHARGEABLE_SALE";
export const NON_CHARGEABLE_SALE_APPLY = "NON_CHARGEABLE_SALE_APPLY";
export const EDIT_CHARGE = "EDIT_CHARGE";
export const BILL_SETTLEMENT = "BILL_SETTLEMENT";
export const SEND_DIGITAL_BILL = "SEND_DIGITAL_BILL";
export const EDIT_AFTER_PRINT = "EDIT_AFTER_PRINT";
export const TRANSFER_ITEMS = "TRANSFER_ITEMS";
export const MANAGE_PRINTERS = "MANAGE_PRINTERS";
export const POS_PREFERENCES = "POS_PREFERENCES";
export const UPDATE_CLOSED_SALE = "UPDATE_CLOSED_SALE";
export const REPRINT_POST_SETTLEMENT = "REPRINT_POST_SETTLEMENT";
export const SPLIT_PAYMENTS = "SPLIT_PAYMENTS";
export const CASH_SETTLEMENT = "CASH_SETTLEMENT";
export const PETTY_CASH_MANAGEMENT = "PETTY_CASH_MANAGEMENT";
export const MANAGE_RESOURCE = "MANAGE_RESOURCE";
/** ⚠️ Value is `"DAILY_CLOSING"`, not `"CASH_MANAGEMENT"` — verbatim from both apps. */
export const CASH_MANAGEMENT = "DAILY_CLOSING";
export const MANUAL_BRANCH_CLOSE = "MANUAL_BRANCH_CLOSE";
export const TIN_ENTRY = "TIN_ENTRY";
export const CUSTOMER_EDIT = "CUSTOMER_EDIT";
export const EDIT_SERVICE_TICKET = "EDIT_SERVICE_TICKET";
export const OPEN_ORDER_PRINT = "OPEN_ORDER_PRINT";
export const CASH_REGISTER = "CASH_REGISTER";
export const MARK_OUT_OF_STOCK = "MARK_OUT_OF_STOCK";
/** ⚠️ camelCase VALUES, unlike every neighbour — verbatim from both apps. */
export const RESTRICT_MANUAL_SOLD_OUT = "restrictManualSoldOut";
export const RESTRICT_MANUAL_STOCK_IN = "restrictManualStockIn";
export const CREATE_ORDERS_ON_RESERVED_TABLE = "CREATE_ORDERS_ON_RESERVED_TABLE";
export const EDIT_CUSTOMER_AFTER_BILL_PRINT = "EDIT_CUSTOMER_AFTER_BILL_PRINT";
export const EDIT_COUPONS_OFFERS_AFTER_BILL_PRINT = "EDIT_COUPONS_OFFERS_AFTER_BILL_PRINT";
export const EDIT_ORDER_AFTER_BILL_PRINT = "EDIT_ORDER_AFTER_BILL_PRINT";
export const EDIT_CHARGE_AFTER_BILL_PRINT = "EDIT_CHARGE_AFTER_BILL_PRINT";
export const OPTION_SET_ACCORDING_TO_DISPLAY_ORDER = "OPTION_SET_ACCORDING_TO_DISPLAY_ORDER";
export const EDIT_CUSTOMER_DISPLAY = "EDIT_CUSTOMER_DISPLAY";
export const EDIT_DELETE_CUSTOMER_NOTE_DISPLAY = "EDIT_DELETE_CUSTOMER_NOTE_DISPLAY";
export const DEVICES = "DEVICES";
export const RETURN_SALE = "RETURN_SALE";
export const REPRINT_KOTS = "REPRINT_KOTS";

/** Identical in both apps. Indexed by name at every call site; never iterated. */
export const MODULES = {
  access: "Access",
  sale: "Sale",
  inventory: "Inventory",
  analytics: "Analytics",
};
